import { useTranslation } from 'react-i18next';
import { useReveal } from '../../hooks/useReveal';

export default function PVScreens() {
  const { t } = useTranslation();
  const ref = useReveal({ stagger: 0.08 });
  const features = t('pv.screens.features', { returnObjects: true });

  return (
    <section
      ref={ref}
      className="section"
      style={{ background: 'var(--p2a-dark-bg)', borderBottom: '1px solid var(--p2a-dark-border)' }}
    >
      <div className="p2-container">
        <div
          className="reveal"
          style={{
            border: '1px solid var(--p2a-dark-border-2)',
            borderRadius: 8,
            overflow: 'hidden',
            background: 'var(--p2a-dark-panel)',
          }}
        >
          <div style={{
            padding: '12px 16px',
            borderBottom: '1px solid var(--p2a-dark-border)',
            display: 'flex', alignItems: 'center', gap: 12,
            background: 'var(--p2a-dark-panel-2)',
          }}>
            <div style={{ display: 'flex', gap: 6 }}>
              <span style={{ width: 10, height: 10, borderRadius: '50%', background: '#fb7185' }} />
              <span style={{ width: 10, height: 10, borderRadius: '50%', background: '#fbbf24' }} />
              <span style={{ width: 10, height: 10, borderRadius: '50%', background: '#34d399' }} />
            </div>
            <div className="mono" style={{
              fontSize: 11, color: 'var(--p2a-dark-fg-4)', letterSpacing: '0.08em',
              padding: '4px 12px',
              background: 'var(--p2a-dark-bg)',
              border: '1px solid var(--p2a-dark-border)',
              borderRadius: 4,
              flex: 1, maxWidth: 360,
            }}>
              app.pix2agro.com.br/pixviewer/TesteMartello
            </div>
            <span className="mono" style={{ fontSize: 10, color: 'var(--p2a-green-400)', letterSpacing: '0.14em' }}>
              {t('pv.screens.status_online')}
            </span>
          </div>
          <img src="/assets/pixviewer_gaps-v2.webp" alt="PixViewer" style={{ width: '100%', display: 'block' }} />
        </div>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: 24,
            marginTop: 64,
          }}
          className="pv-features"
        >
          {features.map((f) => (
            <div
              key={f.t}
              className="reveal pv-feature"
              style={{
                padding: 24,
                background: 'var(--p2a-dark-panel)',
                border: '1px solid var(--p2a-dark-border)',
                borderRadius: 6,
                transition: 'border-color var(--p2a-dur-base) var(--p2a-ease), transform var(--p2a-dur-base) var(--p2a-ease)',
              }}
              onMouseEnter={(e) => { e.currentTarget.style.borderColor = 'var(--p2a-green-500)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.borderColor = 'var(--p2a-dark-border)'; e.currentTarget.style.transform = 'translateY(0)'; }}
            >
              <div className="mono" style={{ fontSize: 11, letterSpacing: '0.14em', color: 'var(--p2a-green-400)', marginBottom: 12 }}>
                {t('pv.screens.feature_label')}
              </div>
              <h3 className="h-3" style={{ marginBottom: 10 }}>{f.t}</h3>
              <p style={{ fontSize: 14, color: 'var(--p2a-dark-fg-3)' }}>{f.d}</p>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 820px) { .pv-features { grid-template-columns: 1fr !important; } }
      `}</style>
    </section>
  );
}
